import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-withdrawal-redirect-dialog',
  templateUrl: './withdrawal-redirect-dialog.component.html',
  styleUrls: ['./withdrawal-redirect-dialog.component.scss']
})
export class WithdrawalRedirectDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<WithdrawalRedirectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { redirectUrl: string },
  ) { }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

}
